import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useRef } from 'react';
import { StyledSpinner } from '../styled-spinner/styled-spinner';
import { AgendaCarousel } from './components/agenda-carousel';
import styled from 'styled-components';
import useSortedAgenda from './hooks/use-sorted-agenda';

const Background = styled.div`
	background: linear-gradient(180deg, #ffffff 0%, #dfe4e8 67%);
`;

export const Agenda = (): React.ReactElement => {
	const sectionRef = useRef<HTMLElement>(null);
	const agenda = useSortedAgenda();

	return (
		<Background>
			<section ref={sectionRef}>
				{agenda && agenda.agendas.length > 0 ? (
					<Container
						data-testid="agenda-container"
						padding={{
							top: ContainerPadding.dynamic0150,
							bottom: ContainerPadding.dynamic0150,
						}}
						wrap="always"
						gutter={ContainerGutter.dynamic0100}
					>
						<Layout
							data-testid="agenda-title-layout"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 1 },
									{ name: 'agenda-title', columns: 22 },
									{ name: '.', columns: 1 },
								],
							}}
						>
							<Container data-testid="agenda-section-title" wrap="always">
								<Text
									appearance={TokenTextAppearance.bigcopy200}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
									bold
								>
									Novedades
								</Text>
								<Text
									appearance={TokenTextAppearance.headline500}
									color={TokenTextColor.primary}
									textAlign={TextAlignment.left}
								>
									Entérate de <b>lo último</b>
								</Text>
							</Container>
						</Layout>

						<Layout
							data-testid="agenda-carousel-layout"
							appearance={{
								[Breakpoints.default]: [{ name: 'agenda-carousel', columns: 24 }],
							}}
						>
							<AgendaCarousel agendas={agenda.agendas} key="second_div" data-testid="agendas-carousel" />
						</Layout>
					</Container>
				) : (
					<StyledSpinner variant="x-large" />
				)}
			</section>
		</Background>
	);
};
